import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * `/explorer` was Pages' address while it was a Windows 7 window. Links,
 * bookmarks and search results that still point there land in the drive at
 * the same place, query and all (`?folder=`, `?preview=`, `?node=`).
 */
export function ExplorerRedirect() {
  const { spaceId } = useParams<{ spaceId?: string }>();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (params.get('view') === 'computer' || params.get('view') === 'folder') params.delete('view');
  const query = params.toString();
  return <Navigate replace to={`/pages${spaceId ? `/${spaceId}` : ''}${query ? `?${query}` : ''}`} />;
}
